import Index from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Navigation from "@frog/source/models/Navigation.js"

export function serialize(snapshot) {
    if(snapshot.alphastage.world.reference != undefined) {
        snapshot.alphastage.world = {"reference": snapshot.omegastage.world.reference}
    }
    if(snapshot.omegastage.world.reference != undefined) {
        snapshot.omegastage.world = {"reference": snapshot.omegastage.world.reference}
        // TODO: ALSO PRESERVE ANYTHING DIFFERENT FROM THE REFERENCED STAGE. THIS'LL
        // BE EASIER TO DO IF YOU CAN JUST STORE DELTAS OF THE ORIGINAL REFERENCED STUFF
        // AS YOUR IN-MEMORY FORMAT, A PROTOTYPE OR PREFAB PATTERN.
    }
    return JSON.stringify(snapshot)
}

export function acceptOmegastage(test) {
    return import(/* webpackChunkName: "test.js" */"@frog/source/tests/_.js").then((module) => {
        const tests = module.default

        test = test || tests.find((test) => test.slug == Navigation.state.testslug)
        if(test == undefined) {
            throw "Could not find test " + Navigation.state.testslug
        }
        const snapshot = serialize({
            "alphastage": Stage.copy(test.snapshot.alphastage),
            "protoactions": test.snapshot.protoactions, // not safe copied yet
            "omegastage": Stage.copy(test.computedOmegastage),
        })
        console.log("Copied snapshot to the clipboard!!")
        window.copy(snapshot)
        return snapshot
    })
}

if(typeof window != "undefined") {
    window.frog = window.frog || {}
    window.frog.test = window.frog.test || {}
    window.frog.test.record = function() {
        if(window.frog.test.snapshot == undefined) {
            window.frog.test.snapshot = {
                "alphastage": Stage.copy(Index.game.encounter.stage),
                "protoactions": [],
            }
            console.log("Recording snapshot...")
            console.log("Call again when you're done recording.")
        } else if(window.frog.test.snapshot != undefined) {
            window.frog.test.snapshot.omegastage = Stage.copy(Index.game.encounter.stage)
            console.log("Copied snapshot to the clipboard!!")
            window.copy(serialize(window.frog.test.snapshot))
            const snapshot = window.frog.test.snapshot
            delete window.frog.test.snapshot
            return snapshot
        }
    }
    window.frog.test.acceptOmegastage = acceptOmegastage
}
